// src/components/NetworkStatus.tsx
import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { Wifi, WifiOff } from 'lucide-react';
import { useNetwork } from '../context/NetworkContext';

export const NetworkStatus = () => {
  const { isOnline, pendingOfflineChanges } = useNetwork();
  const [showMessage, setShowMessage] = useState(false);
  
  useEffect(() => {
    const handleOnline = () => {
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 3000);
    };
    
    const handleOffline = () => {
      setShowMessage(true);
    };
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    // Show message initially if offline
    if (!isOnline) {
      setShowMessage(true);
    }
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [isOnline]);
  
  // Don't show on web unless offline or message active
  if (!Capacitor.isNativePlatform() && isOnline && !showMessage) {
    return null;
  }
  
  return (
    <div className={`fixed bottom-20 left-0 right-0 mx-auto w-auto max-w-[280px] z-50 transition-all duration-300 ${showMessage ? 'opacity-100' : 'opacity-0'} ${isOnline ? 'bg-green-100' : 'bg-red-100'} rounded-full px-4 py-2 flex items-center justify-center shadow-lg`}>
      {isOnline ? (
        <>
          <Wifi size={18} className="text-green-600 mr-2" />
          <span className="text-green-800 text-sm font-medium">
            {pendingOfflineChanges 
              ? 'Back online! Syncing data...' 
              : 'Connected'}
          </span>
        </>
      ) : (
        <>
          <WifiOff size={18} className="text-red-600 mr-2" />
          <span className="text-red-800 text-sm font-medium">Offline mode - changes saved locally</span>
        </>
      )}
    </div>
  );
};